const messages = {
  title: "Obchod",
  description: "Vitajte v obchode s odmenami. Tu si môžete uplatniť svoje body Bridgestone Plus <br/> za odmeny z rôznych kategórií. Ponuka produktov <br/> je pravidelne aktualizovaná. Dúfame, že si prehliadanie užijete.",
  sort: {
    asc: "Zoradiť podľa: Najnižšia cena",
    desc: "Zoradiť podľa: Najvyššia cena",
  },
  productSearchBox: {
    from: "body od",
    to: "body do",
  },
  noProducts: "Vyhľadávacie kritériá nepriniesli žiadne výsledky",
  quantity: "Množstvo",
  search: "Hľadať",
  perPage: "Položiek na stránku",
  timeUnavailable: "Momentálne nie je k dispozícii",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Body / jednotka",
    pointsSum: "Súčet bodov",
  },
  action: "Akcia",
  pointsTotal: "Celkom",
  cartRemainPoints: "Zostávajúce body v košíku",
  shoppingCart: "Nákupný košík",
  emptyCart: "Nákupný košík je prázdny.",
  attributes: "Atribúty",
  selectAddressP: "Vyberte prosím doručovaciu adresu",
  orderDelivery: "Doručovacia adresa",
  selectedProducts: "Vybrané produkty",
  orderSummary: "Prehľad objednávky",
  contactPerson: "Kontaktná osoba",
  selectedAddress: "Vybraná adresa",
  order: {
    success: "Ďakujeme! Vaša objednávka bola úspešná. O niekoľko minút dostanete potvrdenie objednávky do svojej schránky.",
    description: "Tu nájdete prehľad svojich objednávok z obchodu s odmenami.",
    info: "Tu nájdete prehľad svojich objednávok z obchodu s odmenami.",
    date: "Dátum objednávky",
    number: "Č. objednávky",
    status: {
      created: "Vytvorené",
      confirm_order: "Potvrdiť objednávku",
      ready_for_shipment: "Pripravené na odoslanie",
      rejected: "Zamietnuté",
      processed: "Spracované",
      shipped: "Odoslané",
      returned: "Vrátené",
      finished: "Dokončené",
    },
    anyOrder: "Žiadne objednávky",
    products: "Produkty",
    quantity_short: "ks",
    itemRemoved: "nedá sa doručiť",
  },
  orders: "Objednávky",
  notEnoughPoints: "Nemáte dostatok bodov.",
  statusText: "Stav",
  outOfStock: "Momentálne nie je na sklade",
  productUnavailable: "Tento produkt už nie je k dispozícii.",
  deletedProductsTitle: "Produkty už nie sú k dispozícii",
  deletedProductsMessage: "Nasledujúce produkty už nie sú k dispozícii. Odstráňte ich z košíka, aby ste mohli pokračovať.",
  removeSelected: "Odstrániť vybrané",
  clearCart: "Vyprázdniť košík",
  removeSelectedConfirm: "Odstrániť vybrané produkty z košíka?",
  clearCartConfirm: "Odstrániť všetky produkty z košíka?",
  incompleteAddress: {
    firstName: "Pridajte k doručovacej adrese krstné meno",
    lastName: "Pridajte k doručovacej adrese priezvisko",
    company: "Pridajte k doručovacej adrese názov spoločnosti",
    street: "Pridajte k doručovacej adrese ulicu a číslo domu",
    postalCode: "Pridajte k doručovacej adrese PSČ",
    city: "Pridajte k doručovacej adrese mesto",
    country: "Pridajte k doručovacej adrese krajinu",
    phone: "Pridajte k doručovacej adrese telefónne číslo",
  },
  placeOrder: "Závazná objednávka",
  toOrderDelivery: "Pokračovat na doručovací adresu",
  toOrderSummary: "Přejít na přehled objednávky",
  productImg: "Obrázek produktu",
  selectAddressBtn: "Vybrat adresu",
  perPgae: "Položiek na stránku",
  categories: {
    advertising: {
      title: "Reklamní materiály",
      desc: "Zúčastněte se přímo zde na platformě a získejte <br/> 40 extra bodů pro odměnový klub.",
    },
    rewards: {
      title: "Exkluzivní odměny",
      desc: "Objevte bonusovou nabídku v našem školicím centru nebo u vás na místě.",
    },
    tools: {
      title: "Nářadí pro dílnu",
      desc: "Využijte body na školení třetích stran <br/> a snižte své náklady.",
    },
    trainings: {
      title: "Školení a kurzy",
      desc: "Objevte bonusovou nabídku v našem školicím centru nebo u vás na místě.",
    },
    salesroom: {
      title: "Prodejna",
      desc: "Upravte prodejnu a nabídněte zákazníkům příjemný pobyt.",
    },
    hunter: {
      title: "Hunter",
      desc: "Vyměňte body za atraktivní vybavení dílny od Hunter.",
    },
  },
  bestSold: "Nejprodávanější",
  seasonal: "Sezónní",
  affordable: "Skoro hotovo",
  forPoints: "za {points} bodů",
  reachedPoints: "Požadovaný počet bodů dosažen",
  remainingPoints: "Chybí {points} bodů",
  favoriteProducts: {
    description: "Tu nájdete uložené produkty.",
  },
  categoryPageDescriptionFallback: "Materiál do dielne alebo iné kvalitné produkty s logom Bridgestone pre vašu firmu",
  variant: "Voliteľné varianty",
};
export default {
  messages,
};
